import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {Footer} from '../../organisms/Footer/Footer';
import {FooterType} from './FooterType.enum';

export function LayoutFooter({
  isMobile: _isMobile,
  shouldShowFooterLinkMenu,
  footerType,
}: {
  isMobile?: boolean;
  shouldShowFooterLinkMenu?: boolean;
  footerType: FooterType;
}) {
  const isMobile = _isMobile ?? requestContext.requestInfo.display.isMobile;
  return (
    <Footer
      isMobile={isMobile}
      shouldShowFooterLinkMenu={shouldShowFooterLinkMenu}
      className={twMerge(
        !isMobile && 'mt-84pxr',
        isMobile && footerType === FooterType.ContentHome && 'mb-60pxr',
        isMobile && footerType === FooterType.DayOfWeek && 'mt-10pxr'
      )}
    />
  );
}
